<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header"><h3>법정대리인(보호자)</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              보호자명
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  {{ registration.lawcAgntNmMask }}
                </p>
              </div>
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              주민등록번호
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  <span>{{ ssn1 }}</span>
                  <span class="field-group-space">-</span>
                  <span>{{ ssn2 }}</span>
                </p>
              </div>
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              연락가능 전화번호
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  {{ retrieveData.lawcAgntTlnoMask }}
                </p>
              </div>
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              주소
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  <span>{{ registration.lawcAgntZpcd }}</span
                  >&nbsp;
                  <span class="field-group-space">{{
                    registration.lawcAgntAddr
                  }}</span
                  >
                  <!-- 상세주소 제거 -->
                  <!-- &nbsp;
                  <span class="field-group-space">{{
                    registration.lawcAgntDadr
                  }}</span> -->
                </p>
              </div>
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              <label>법정대리인 동의</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text" v-if="registration.lawcAgntAgrYn === 'Y'">
                  동의
                </p>
                <p class="data-text" v-if="registration.lawcAgntAgrYn === 'N'">
                  미동의
                </p>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
export default {
  name: 'RegistrationStep2SectionGuardian',
  props: {
    registrationProps: Object,
    lawcAgntEntrRsvTruthInfoProps: Object
  },

  data() {
    return {
      registration: {},
      lawcAgntEntrRsvTruthInfo: {},
      ssn1: '',
      ssn2: '',
      retrieveData: {
        lawcAgntTlnoMask: ''
      }
    }
  },

  mounted() {
    this.registration = this.registrationProps
    this.lawcAgntEntrRsvTruthInfo = this.lawcAgntEntrRsvTruthInfoProps
    this.ssn1 = this.registration.lawcAgntCrypRrnoMask.substr(0, 6)
    this.ssn2 = this.registration.lawcAgntCrypRrnoMask.substr(6, 7)
    this.retrieveData.lawcAgntTlnoMask = this.formatPhoneNumber(
      this.registration.lawcAgntTlnoMask
    )
  },

  methods: {
    /** 
     * Function    : formatPhoneNumber
     * Description : 휴대폰 번호 formatting
     **/
    formatPhoneNumber(phoneNum) {
      if (phoneNum.length === 10) {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 6) +
          '-' +
          phoneNum.substring(6, 10)
        )
      } else {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 7) +
          '-' +
          phoneNum.substring(7, 11)
        )
      }
    }
  }
}
</script>

<style scoped></style>
